export default __webpack_public_path__ + "d952d141b2fe2386c5597ca4b2228494.jpg";